module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Regular.e63c5168.ttf";